import '../../scss/parts/forecastPageTemplate.scss';
import '../../scss/parts/datepicker.scss';
import forecastDatePicker from "../widgets/foreastDatePicker.js";
import priceChart from "../widgets/priceChart.js";
import getForecastWidgetData from "../services/forecastWidgetData.js";

(function ($) {
    $(function () {
        priceChart.init($);
        const widget = document.querySelector('.forecast-date-widget-wrapper');
        if (!widget) return;
        const loadData = () => getForecastWidgetData(widget.dataset.coinId);
        const renderedCharts = new Set();
        const chartIds = ['chartWeekAhead', 'chartYearAhead'];
        const renderCharts = data => {
            for (const id of chartIds) {
                if (renderedCharts.has(id)) continue;
                try {
                    priceChart.renderChart(id, data.charts?.[id]);
                    renderedCharts.add(id);
                } catch (error) {
                    console.error('Forecast chart:', id, error);
                    priceChart.showError(id);
                }
            }
        };

        // Each widget must start even when another chart or the date API fails.
        loadData().then(renderCharts).catch(error => {
            console.error('Forecast charts:', error);
            for (const id of chartIds) {
                priceChart.showError(id);
            }
        });

        forecastDatePicker.init($, () => loadData().then(data => {
            renderCharts(data);
            return data.dates;
        })).catch(error => {
            console.error('Forecast date widget:', error);
        });
    });
}(jQuery));
